import React from "react";

import { Input } from "../../../common/u1/Input";
import { CountrySelect } from "../../../common/u1/CountrySelect";
import { PhoneCountrySelect } from "../../../common/u1/PhoneCountrySelect";
import { FieldLabel } from "../../../common/u1/FieldLabel";
import PhoneNumberInput from "../../../common/PhoneNumberInput";
import { EditDialog } from "./EditDialog";
import { usePersonForm } from "./usePersonForm";

/* Add / edit a signatory or a key person — one dialog for both. */
export const PersonFormModal = ({ spec, editing, onClose, onSaved }) => {
  const { values, setField, errors, busy, submit } = usePersonForm(spec, {
    editing,
    onSaved,
  });

  return (
    <EditDialog
      title={editing ? spec.dialogEdit : spec.dialogAdd}
      onClose={onClose}
      ctaLabel={spec.cta}
      onSubmit={submit}
      submitting={busy}
    >
      <Input
        label="Full Name"
        id={`u1-${spec.key}-name`}
        value={values.name}
        onChange={(e) => setField("name", e.target.value)}
        error={errors.name}
        placeholder="Enter full name"
      />

      <Input
        wrapperClassName="mt-3.5"
        label="Designation"
        id={`u1-${spec.key}-designation`}
        value={values.designation}
        onChange={(e) => setField("designation", e.target.value)}
        error={errors.designation}
        placeholder="Enter designation"
      />

      <Input
        wrapperClassName="mt-3.5"
        label="Work Email"
        id={`u1-${spec.key}-email`}
        type="email"
        value={values.email}
        onChange={(e) => setField("email", e.target.value)}
        error={errors.email}
        placeholder="Enter work email"
      />

      <div className="mt-3.5">
        {/* PhoneNumberInput renders its own control, so this is a span rather
            than a label pointing at nothing. */}
        <FieldLabel as="span" variant="field">
          Work Phone
        </FieldLabel>
        <PhoneNumberInput
          id={`u1-${spec.key}-phone`}
          phone={values.phone}
          setPhone={(next) => setField("phone", next)}
          border
          verifyPhoneNumber={false}
          /* The dial-code picker is the same searchable menu as the country
             fields, so the dialog does not carry two different ones. */
          countrySelect={PhoneCountrySelect}
          /* UAE, not the viewer's geo-detected country: this is a UAE
             business directory and the number being entered is the
             company's, not the person filling the form in. */
          defaultCountry="AE"
        />
        {errors.phone && (
          <p role="alert" className="mt-1.5 text-[12px] text-[var(--coral-deep)] font-sans">
            {errors.phone}
          </p>
        )}
      </div>

      {/* Transcribed: only the signatory carries a nationality. */}
      {spec.withNationality && (
        <CountrySelect
          className="mt-3.5"
          label="Nationality"
          labelVariant="field"
          id={`u1-${spec.key}-nationality`}
          value={values.nationality}
          onChange={(c) => setField("nationality", c?.code)}
          error={errors.nationality}
          placeholder="Select a country"
        />
      )}

      {errors.form && (
        <p role="alert" className="mt-3 text-[12px] text-[var(--coral-deep)] font-sans">
          {errors.form}
        </p>
      )}
    </EditDialog>
  );
};

export default PersonFormModal;
